module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "id": "_idContainer003",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "pl-fl-roman"
  }, [_c('b', [_vm._v("Elizabeth Goddard")]), _vm._v(" is the award-winning author of more than thirty novels and novellas. A 2011 Carol Award winner, she was a double finalist in the 2016 Daphne du Maurier Award for Excellence in Mystery/Suspense, and a 2016 Carol Award finalist. Elizabeth graduated with a computer science degree and worked in high-level software sales before retiring to write full-time.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_c('b', [_vm._v("Books by Elizabeth Goddard")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-series"
  }, [_c('b', [_vm._v("Love Inspired Suspense")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("Fugitive Trail")])]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_vm._v("Mount Shasta Secrets")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Deadly Evidence")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_vm._v("Coldwater Bay Intrigue")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Thread of Revenge")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Stormy Haven")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Distress Signal")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Running Target")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_vm._v("Texas Ranger Holidays")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Texas Christmas Defender")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-miniseries"
  }, [_vm._v("Wilderness, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Targeted for Murder")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Undercover Protector")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("False Security")]), _vm._v(" "), _c('p', {
    staticClass: "pl-booklist-titles"
  }, [_vm._v("Wilderness Reunion")]), _vm._v(" "), _c('p', {
    staticClass: "pl-center"
  }, [_vm._v("Visit the Author Profile page"), _c('br'), _vm._v("at "), _c('a', {
    attrs: {
      "href": "http://www.Harlequin.com",
      "target": "_blank"
    }
  }, [_vm._v("Harlequin.com")]), _vm._v(" for more titles.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea3609bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About_the_Author.vue
// module id = 66
// module chunks = 0